/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ orderNumber: NonNullable<unknown> }} Orders_Order_LabelInputs */

const en_orders_order_label = /** @type {(inputs: Orders_Order_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Order ${i?.orderNumber}`)
};

const es_orders_order_label = /** @type {(inputs: Orders_Order_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pedido ${i?.orderNumber}`)
};

/**
* | output |
* | --- |
* | "Order {orderNumber}" |
*
* @param {Orders_Order_LabelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_order_label = /** @type {((inputs: Orders_Order_LabelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Order_LabelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_order_label(inputs)
	return es_orders_order_label(inputs)
});